// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/InstagramAccounts_ToggleActiveResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /instagram/accounts/toggle_active
 *
 * Action endpoint — emits a confirmation message reflecting the new active
 * state ("Conta ativada!" / "Conta desativada!").
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface InstagramAccounts_ToggleActiveResponseDados {
message: string
}

export type InstagramAccounts_ToggleActiveResponse = ApiResponse<InstagramAccounts_ToggleActiveResponseDados>;

registerResponseContract('InstagramAccounts_ToggleActiveResponse', {
  message: { type: 'string',  required: true },
})
